export default __webpack_public_path__ + "static/wallpapers-26d6f44eb217ec8cfd24dff6cfb30881.png";